import React from "react";
import { ProgressBar } from "react-bootstrap";

function CheckoutProgressModal({ totalOrders = 0 }) {
  const goalOrders = 10;
  const progress = Math.min((totalOrders / goalOrders) * 100, 100);
  const redeemable = progress >= 100;

  return (
    <div
      className="modal fade"
      id="exampleModal1"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog mt70">
        <div
          className="modal-content text-white rounded-4 border-0 mw400"
          style={{
            background: "linear-gradient(135deg, #001F3F 0%, #003B73 100%)"
          }}
        >
          <div className="container shopdtlcontmax d-flex justify-content-left p-4">
            <div className="col-12">
              <div className="ml-3 w-100 text-center">
                {/* ✅ Header */}
                <h2 className="fw800 mb-3">
                    🎁<br/>
                    Unlock Rewards<br/>
                    With Every Order
                </h2>

                <div className="reward-perks text-start mx-auto mb-3">
                    <div className="perk-item">🚚 Free Delivery</div>
                    <div className="perk-item">💸 Instant Discounts</div>
                    <div className="perk-item">⭐ VIP Offers</div>
                    <div className="perk-item">🎉 Bonus Rewards</div>
                </div>

                <p className="small opacity-75 mb-0">
                    Shop as usual. Earn rewards automatically.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default CheckoutProgressModal;
